window.addEventListener('load', () => {

    function appendColorSearch() {

        document.querySelectorAll('.po-option--swatch-container').forEach((swatchContainer) => {

            const swatchItems = swatchContainer.querySelectorAll('.po-option--swatch-wrapper');

            // Show search only if more than 10 swatches
            if (swatchItems.length <= 10) {
                return;
            }

            // Already exists
            if (
                swatchContainer.previousElementSibling &&
                swatchContainer.previousElementSibling.classList.contains('color-search-box')
            ) {
                return;
            }

            swatchContainer.insertAdjacentHTML(
                'beforebegin',
                `
                <div class="color-search-box">
                    <span class="search-icon">
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                            <circle cx="11" cy="11" r="7" stroke="currentColor" stroke-width="2"/>
                            <path d="M20 20L17 17" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                        </svg>
                    </span>

                    <input
                        type="text"
                        class="color-search-input"
                        placeholder="Type a color name"
                    >

                    <button type="button" class="clear-search" aria-label="Clear">
                        ✕
                    </button>
                </div>
                `
            );
        });

        // Remove search boxes if swatch container doesn't exist
        document.querySelectorAll('.color-search-box').forEach((searchBox) => {

            const nextElement = searchBox.nextElementSibling;

            if (
                !nextElement ||
                !nextElement.classList.contains('po-option--swatch-container')
            ) {
                searchBox.remove();
            }
        });
    }

    setTimeout(() => {

        appendColorSearch();

        const observer = new MutationObserver(() => {
            appendColorSearch();
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });

    }, 1000);

    // Search functionality
    document.addEventListener('input', (e) => {

        if (!e.target.matches('.color-search-input')) return;

        const term = e.target.value.trim().toLowerCase();

        const searchBox = e.target.closest('.color-search-box');

        if (!searchBox) return;

        const swatchContainer = searchBox.nextElementSibling;

        if (
            !swatchContainer ||
            !swatchContainer.classList.contains('po-option--swatch-container')
        ) {
            return;
        }

        swatchContainer
            .querySelectorAll('.po-option--swatch-wrapper')
            .forEach((item) => {

                const radio = item.querySelector('input[type="radio"]');

                if (!radio) return;

                const text = (radio.value || '').toLowerCase();

                item.style.display = text.includes(term)
                    ? ''
                    : 'none';
            });
    });

    // Clear button
    document.addEventListener('click', (e) => {

        const clearBtn = e.target.closest('.clear-search');

        if (!clearBtn) return;

        const searchBox = clearBtn.closest('.color-search-box');

        const input = searchBox.querySelector('.color-search-input');

        if (input) {
            input.value = '';
        }

        const swatchContainer = searchBox.nextElementSibling;

        if (
            swatchContainer &&
            swatchContainer.classList.contains('po-option--swatch-container')
        ) {
            swatchContainer
                .querySelectorAll('.po-option--swatch-wrapper')
                .forEach((item) => {
                    item.style.display = '';
                });
        }
    });

});